<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <ValidationProvider
            rules="required"
            vid="school"
            :name="$t('fields.school').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-select
            v-model="form.schoolLocation"
            item-value="id"
            :items="locations"
            :label="$t('fields.school')"
            :error-messages="errors"
            return-object
          >
            <template v-slot:selection="{ item }">
                {{ item.options.branch_code }} {{ item.city }} {{ item.street }}
            </template>

            <template v-slot:item="{ item }">
               {{ item.options.branch_code }} {{ item.city }} {{ item.street }}
            </template>

          </v-select>
        </ValidationProvider>
        <v-row>
          <v-col
            cols="6"
          >
            <ul
              v-if="Object.keys(form.schoolLocation).length"
            >
              <li>{{ $t('fields.code') }}: {{ form.schoolLocation.code }}</li>
              <li>{{ $t('fields.city') }}: {{ form.schoolLocation.city }}</li>
              <li>{{ $t('fields.zipcode')}}: {{ form.schoolLocation.postalcode }}</li>
              <li>{{ $t('fields.email') }}: {{ form.schoolLocation.email }} {{ form.schoolLocation.options.email_2 }} {{ form.schoolLocation.options.email_3 }}</li>
              <li>{{ $t('fields.phone') }}: {{ form.schoolLocation.phone }} {{ form.schoolLocation.options.phone_2 }} {{ form.schoolLocation.options.phone_3 }} </li>
              <li>{{ $t('fields.address') }}: {{ form.schoolLocation.street }}</li>
              <li>{{ $t('fields.note') }}: {{ form.schoolLocation.options.note }}</li>
              <li>{{ $t('fields.website') }}: {{ form.schoolLocation.options.website }}</li>
              <li>{{ $t('fields.entry_time') }}: {{ form.schoolLocation.options.entry_time }}</li>
              <li>{{ $t('fields.ricreation_time') }}: {{ form.schoolLocation.options.ricreation_time }}</li>
              <li>{{ $t('fields.ricreation_time_2') }}: {{ form.schoolLocation.options.ricreation_time_2 }}</li>
            </ul>
          </v-col>
          <v-col
            cols="6"
          >
            <ul
              v-if="Object.keys(form.schoolLocation).length"
            >
              <li
                v-if="form.schoolLocation.options.elementary_classes.length"
              >
                {{ $t('fields.elementary_school') }}:
                <span
                  class="mt-1"
                  v-for="(item, index) in form.schoolLocation.options.elementary_classes"
                  :key="index">
                  <br /> {{ index+1 }} {{ item }}
                </span>
              </li>
              <li
                v-if="form.schoolLocation.options.primary_classes.length"
              >
                {{ $t('fields.primary_school') }}:
                <span
                  class="mt-1"
                  v-for="(item, index) in form.schoolLocation.options.primary_classes"
                  :key="index">
                  <br /> {{ index+1 }} {{ item }}
                </span>
              </li>
              <li
                v-if="form.schoolLocation.options.secondary_classes.length"
              >{{ $t('fields.secondary_school') }}:
                <span
                  class="mt-1"
                  v-for="(item, index) in form.schoolLocation.options.secondary_classes"
                  :key="index"
                >
                  <br />{{ index+1 }} {{ item }}
                </span>
              </li>
            </ul>
          </v-col>
        </v-row>
    </ValidationObserver>

    </v-card-text>
    <v-card-actions>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { schoolsLocationsService } from '../../../utils/services/schoolsLocations.service';

  export default {
    name: 'SchoolAdditionalInfoModal',
    components: { },
    data() {
      return {
        stored: null,
        locations: [],
        form: {
          id: 0,
          schoolLocation: {},
        },
        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      cancel() {
        this.hideModal({});
      },
      async fetchSchoolLocation() {
        return schoolsLocationsService.index(this.form.id)
        .then(response => {
            this.locations = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
    },
    async created() {
      this.loadingModal(true);
      console.log(this.data);
      if (this.data.stored) {
        if (this.data.stored.id) {
          this.form.id = this.data.stored.id;
          await this.fetchSchoolLocation();
        }
      }
      this.loadingModal(false);
    },
  };
</script>
